import { render, staticRenderFns } from "./ProfilePM.vue?vue&type=template&id=0610719c&scoped=true&lang=pug&"
import script from "./ProfilePM.vue?vue&type=script&lang=js&"
export * from "./ProfilePM.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePM.vue?vue&type=style&index=0&id=0610719c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0610719c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0610719c')) {
      api.createRecord('0610719c', component.options)
    } else {
      api.reload('0610719c', component.options)
    }
    module.hot.accept("./ProfilePM.vue?vue&type=template&id=0610719c&scoped=true&lang=pug&", function () {
      api.rerender('0610719c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProfilePM.vue"
export default component.exports